import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { Patrimony } from 'src/app/shared/interfaces/patrimony.interface';
import { PatrimonyService } from '../patrimony.service';

@Component({
  selector: 'app-patrimony-list',
  templateUrl: './patrimony-list.component.html',
  styleUrls: ['./patrimony-list.component.css'],
})
export class PatrimonyListComponent implements OnInit {
  patrimonies: Patrimony[] = [];

  constructor(
    private patrimonyService: PatrimonyService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrService
  ) {
    this.get();
  }

  displayedColumns: string[] = ['id', 'descrição', 'actions'];
  dataSource = new MatTableDataSource<Patrimony>();
  searchValue = '';
  @ViewChild(MatPaginator) paginator: MatPaginator;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {}

  get(): Promise<any> {
    return this.patrimonyService.get().then((res) => {
      this.patrimonies = res;
    });
  }

  delete(id: number, description: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      height: '250px',
      data: {
        title: 'Excluir',
        text: ' Deseja remover o patrimônio ? ',
        name: description,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.patrimonyService
          .delete(id)
          .then((res: any) => {
            this.snackBar.open(res.message, null, {
              duration: 4000,
            });
          })
          .catch((err: any) => {
            this.snackBar.open(err.error.message || 'Algo de errado aconteçeu');
          });
      }
    });
  }

  search(searchValue: string): Promise<any> {
    return this.patrimonyService
      .search(searchValue)
      .then((res) => {
        this.patrimonies = res;
      })
      .catch((err) => {
        this.toastr.error(err.error.message || 'Falha na busca');
      });
  }
}
